import { get, post, put, destroy as del } from "./base";

const BannerServ = {
    index: (params) => get("/banners", { params }),
    create: (data) => post("/banners", data),
    update: (id, data) => put(`/banners/${id}`, data),
    remove: (id) => del(`/banners/${id}`),
    uploadImage: (formData) => post("/upload/image", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
};

export default BannerServ;
